import { InputAdornment } from "@mui/material";

const dayEndAdornment = {
  InputProps: {
    endAdornment: (
      <InputAdornment position="end" sx={{ "& .MuiTypography-root": { fontSize: "14px" } }}>
        day
      </InputAdornment>
    ),
  },
};

export default dayEndAdornment;
